import moment from "moment";

// APP TEXT
export const APP_TITLE = 'Welcome, Zen Pensions';
export const FOOTER_COPYRIGHTS_TEXT = `©${new Date().getFullYear()} Zen Pensions - All Rights Reserved`;

// UI CONSTANTS
export const FOOTER_HEIGHT = 30;
export const HEADER_HEIGHT = 60;
export const DRAWER_WIDTH = 250;

export const FIREBASE_VAPID_KEY = 'BBNhyaZZuuwjirzGSqbFm4PE-O9GuWSEb7ynUnH-N84SMkqawLb5VcXWfbCQckAfD93Sq1SRCw86_WQQfxgDEpk';

export const REPORT_DOWNLOAD_LINK = 'Bank_File_Record_Report.xlsx'


export const tradingKeys = {
    TRADING_PHONE: 'tradingPhoneNumber',
    TRADING_EMAIL: 'tradingEmail',
}

export const euroSymbol = {
    EURO: '\u20AC',
}

export const countryType = {
    EURO: 'en-IE',
    RUPEE: 'en-IN',
    DOLAR: 'en-Us'
}

export const currencySymbol = {
    EURO: '\u20AC',
    RUPEE: '₹',
    DOLAR: '$'
}


export const reportFilterBy = [
    { text: 'Record Created At', value: 'created_at' },
    { text: 'Reconciled At', value: 'reconciled_at' },
    { text: 'Order Placed At', value: 'order_placed_at' },
    { text: 'Status Type Updated At', value: 'status_type_updated_at' },
];

export const zpUserUniqueId = 'ZPUSER0000001';
export const zpUserEmail = 'zpuser@zenpensions.com';

export const getOrdinalSuffix = (number: number): string => {
    if (number >= 11 && number <= 13) return 'th';
    switch (number % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};

export const getMonthFullName = (monthNumber: number): string => {
    return moment().month(monthNumber - 1).format("MMMM");
};

export const getFortnightLabel = (fortnightNumber: number): string => {
    return `${fortnightNumber}${getOrdinalSuffix(
        fortnightNumber,
    )} Fortnight`;
};

export const getWeekLabel = (weekNumber: number): string => {
    return `${weekNumber}${getOrdinalSuffix(weekNumber)} Week`;
};

export const getFundType = (type: string): string => {
    switch (type) {
        case 'cash':
            return 'Cash';
        case 'equity':
            return 'Equity';
        case 'bond':
            return 'Bond';
        default:
            return '-';
    }
};

export const BankAccountNumberLength = 22;